import React from 'react'
import { Link, NavLink } from "react-router-dom";

function Pricing() {
    return (
        <section className='pricing position-relative'>
            <span></span>
            <div className="container">
                <div className="work-para d-flex align-items-center justify-content-center flex-column text-center"> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1800" */}
                    <h5>Pricing</h5>
                    <h3>Pricing Plans</h3>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.</p>
                </div>
                <div className="work-hr d-flex align-items-center justify-content-center gap-3">
                    <hr />
                    <h6>Pricing Plans</h6>
                </div>
                <div className="pricing-card d-flex flex-md-row flex-sm-column flex-column justify-content-center text-center mt-5 gap-md-0 gap-sm-4 gap-4">
                    <div className="d-flex align-items-center justify-content-center gap-4 flex-column">
                        <h3>Basic</h3>
                        <h2>$24</h2>
                        <h6>SEO Audits</h6>
                        <h6>SEO Managements</h6>
                        <h6>Diital Marketing</h6>
                        <h6>Site Management</h6>
                        <Link to = "/pricing" className="btn_1 ">Get Started</Link>
                    </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="2000" */}
                    <div className="stan d-flex align-items-center justify-content-center gap-4 flex-column">
                        <h3>Standard</h3>
                        <h2>$594</h2>
                        <h6>SEO Audits</h6>
                        <h6>SEO Managements</h6>
                        <h6>Diital Marketing</h6>
                        <h6>Site Management</h6>
                        <Link to = "/pricing" className="btn_2 ">Get Started</Link>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-4 flex-column">
                        <h3>Premium</h3>
                        <h2>$99</h2>
                        <h6>SEO Audits</h6>
                        <h6>SEO Managements</h6>
                        <h6>Diital Marketing</h6>
                        <h6>Site Management</h6>
                        <Link to = "/pricing" className="btn_1 ">Get Started</Link>
                    </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="2000" */}
                </div>
            </div>
        </section>
    )
}

export default Pricing
